module.exports = __webpack_public_path__ + "img/porto_location_img.1bb6b83b.png";